import { Arrays } from './Arrays'
import { Audio } from './Audio'
import { Bytes } from './Bytes'
import { Dates } from './Dates'
import { Dicts } from './Dicts'
import { Files } from './Files'
import { Generic } from './Generic'
import { Numbers } from './Numbers'
import { Objects } from './Objects'
import { Strings } from './Strings'
import { Urls } from './Urls'

export const Utils = {
  Audio,
  Arrays,
  Bytes,
  Objects,
  Dates,
  Files,
  Strings,
  Numbers,
  Urls,
  Dicts,
  Generic
}
